var LaundryOrbitEngine = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // shop-architect/grok-arcade-handoff-2026-09-16/katie-laura-arcade-handoff/laundry-orbit-working/laundry-orbit.ts
  var laundry_orbit_exports = {};
  __export(laundry_orbit_exports, {
    createLaundryOrbit: () => createLaundryOrbit
  });
  var W = 640;
  var H = 480;
  var HS_KEY = "kl_highscore_orbit";
  var MUTE_KEY = "kl_mute";
  var COLORS = {
    pink: "#ff4da6",
    red: "#e31c3d",
    gum: "#ff8fbf",
    frost: "#f4f0ea",
    gold: "#f0c14b",
    mid: "#6e6e7a",
    bleach: "#d8fff0",
    phone: "#8a8a96"
  };
  var TYPES = ["red", "lipstick", "heel", "pearl", "phone", "purse"];
  function storeGet(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }
  function storeSet(k, v) {
    try {
      localStorage.setItem(k, v);
    } catch (e) {
    }
  }
  function createLaundryOrbit(canvas, onChange) {
    const raw = canvas.getContext("2d");
    if (!raw) throw new Error("Canvas 2D unavailable");
    const ctx = raw;
    const keys = /* @__PURE__ */ new Set();
    const hold = {};
    let extraKeys = [];
    let audioCtx = null;
    let muted = storeGet(MUTE_KEY) === "1";
    let high = Number(storeGet(HS_KEY) || 0) || 0;
    let raf = 0;
    let last = performance.now();
    let destroyed = false;
    const state = {
      mode: "ATTRACT",
      score: 0,
      lives: 10,
      wave: 1,
      ship: null,
      rocks: [],
      shots: [],
      ufo: null,
      bolts: [],
      sparks: [],
      tokens: [],
      toast: null,
      toastT: 0,
      pinkT: 0,
      dimShots: false,
      waveClearT: 0,
      dyingT: 0,
      ufoTimer: 0,
      attractT: 0
    };
    function emit() {
      onChange == null ? void 0 : onChange({
        mode: state.mode,
        score: state.score,
        lives: state.lives,
        wave: state.wave,
        high,
        muted,
        toast: state.toast
      });
    }
    function toast(msg, t = 2.2) {
      state.toast = msg;
      state.toastT = t;
      emit();
    }
    function ensureAudio() {
      if (muted) return null;
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        if (!audioCtx) audioCtx = new AC();
        if (audioCtx.state === "suspended") void audioCtx.resume();
        return audioCtx;
      } catch (e) {
        return null;
      }
    }
    function beep(freq, dur, type, gain) {
      const ac = ensureAudio();
      if (!ac) return;
      try {
        const o = ac.createOscillator();
        const g = ac.createGain();
        o.type = type;
        o.frequency.value = freq;
        g.gain.value = gain;
        g.gain.exponentialRampToValueAtTime(1e-4, ac.currentTime + Math.max(dur, 0.02));
        o.connect(g);
        g.connect(ac.destination);
        o.start();
        o.stop(ac.currentTime + dur);
      } catch (e) {
      }
    }
    function noiseBurst(dur, gain) {
      const ac = ensureAudio();
      if (!ac) return;
      try {
        const n = ac.createBuffer(1, Math.floor(ac.sampleRate * dur), ac.sampleRate);
        const d = n.getChannelData(0);
        for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
        const src = ac.createBufferSource();
        src.buffer = n;
        const f = ac.createBiquadFilter();
        f.type = "lowpass";
        f.frequency.value = 900;
        const g = ac.createGain();
        g.gain.value = gain;
        g.gain.exponentialRampToValueAtTime(1e-4, ac.currentTime + dur);
        src.connect(f);
        f.connect(g);
        g.connect(ac.destination);
        src.start();
      } catch (e) {
      }
    }
    const rand = (a, b) => a + Math.random() * (b - a);
    const wrap = (v, max) => (v % max + max) % max;
    function dist2(a, b) {
      let dx = a.x - b.x;
      let dy = a.y - b.y;
      if (dx > W / 2) dx -= W;
      if (dx < -W / 2) dx += W;
      if (dy > H / 2) dy -= H;
      if (dy < -H / 2) dy += H;
      return dx * dx + dy * dy;
    }
    function angTo(from, to) {
      let dx = to.x - from.x;
      let dy = to.y - from.y;
      if (dx > W / 2) dx -= W;
      if (dx < -W / 2) dx += W;
      if (dy > H / 2) dy -= H;
      if (dy < -H / 2) dy += H;
      return Math.atan2(dy, dx);
    }
    const stars = Array.from({ length: 50 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      s: Math.random() < 0.3 ? 2 : 1,
      a: rand(0.25, 0.8)
    }));
    function makeShip() {
      return {
        x: W / 2,
        y: H / 2,
        vx: 0,
        vy: 0,
        a: -Math.PI / 2,
        r: 11,
        inv: 2,
        smear: 0,
        white: Math.random() < 0.45,
        bleachHits: 0,
        hyperCd: 0,
        fireCd: 0,
        noThrust: 0
      };
    }
    function rockRadius(size) {
      if (size === "L") return rand(34, 40);
      if (size === "M") return rand(20, 24);
      if (size === "S") return rand(10, 14);
      return rand(4.5, 6.5);
    }
    function pointsFor(size) {
      return { L: 20, M: 50, S: 100, B: 10 }[size];
    }
    function makeRock(x, y, size, type, speedMul, garment, cut) {
      const r = rockRadius(size);
      const ang = rand(0, Math.PI * 2);
      const spd = (size === "B" ? rand(40, 90) : rand(22, 52)) * speedMul;
      const g = garment != null ? garment : type === "red" || type === "lipstick" ? "panty" : type === "purse" || type === "phone" ? "bra" : Math.random() < 0.55 ? "panty" : "bra";
      const c = cut != null ? cut : type === "red" ? "ruffle" : ["brief", "lace", "thong", "ruffle"][Math.floor(Math.random() * 4)];
      return {
        x,
        y,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd,
        spin: rand(-0.7, 0.7),
        rot: rand(0, 6),
        r,
        size,
        type,
        garment: g,
        cut: c,
        alive: true
      };
    }
    function spawnWave(n) {
      state.rocks = [];
      const count = 2 + n;
      for (let i = 0; i < count; i++) {
        let x = 0;
        let y = 0;
        let guard = 0;
        do {
          x = rand(0, W);
          y = rand(0, H);
          guard++;
        } while (Math.hypot(x - W / 2, y - H / 2) < 110 && guard < 20);
        let type = TYPES[i % TYPES.length];
        if (n >= 3 && i === 0) type = "red";
        if (n >= 3 && i === 1) type = "pearl";
        state.rocks.push(makeRock(x, y, "L", type, 1 + 0.08 * n));
      }
      state.ufo = null;
      state.bolts = [];
      state.ufoTimer = 0;
      state.waveClearT = 0;
    }
    function splitRock(rock) {
      const kids = [];
      const mul = 1.15;
      if (rock.size === "L" || rock.size === "M") {
        const next = rock.size === "L" ? "M" : "S";
        if (rock.type === "red") {
          kids.push(makeRock(rock.x, rock.y, next, "red", mul, "panty", rock.cut));
          kids.push(makeRock(rock.x, rock.y, next, "red", mul, "panty", rock.cut));
          state.pinkT = 0.45;
          toast("There it is. The red one. Everything's pink now.");
        } else if (rock.type === "heel") {
          kids.push(makeRock(rock.x, rock.y, next, "heel", mul, rock.garment, rock.cut));
          kids.push(makeRock(rock.x, rock.y, "S", "heel", 1.55, rock.garment, rock.cut));
        } else if (rock.type === "pearl") {
          const n = rock.size === "L" ? 6 : 5;
          for (let i = 0; i < n; i++) kids.push(makeRock(rock.x, rock.y, "B", "pearl", 1.2, rock.garment, rock.cut));
        } else if (rock.type === "phone") {
          kids.push(makeRock(rock.x, rock.y, next, "phone", mul, "bra", rock.cut));
          kids.push(makeRock(rock.x, rock.y, next, "phone", mul, "bra", rock.cut));
        } else if (rock.type !== "purse") {
          kids.push(makeRock(rock.x, rock.y, next, rock.type, mul, rock.garment, rock.cut));
          kids.push(makeRock(rock.x, rock.y, next, rock.type, mul, rock.garment, rock.cut));
        }
      }
      return kids;
    }
    function burst(x, y, color, n) {
      for (let i = 0; i < n; i++) {
        const a = rand(0, Math.PI * 2);
        const s = rand(40, 180);
        state.sparks.push({
          x,
          y,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          t: rand(0.25, 0.55),
          color,
          w: rand(1, 3)
        });
      }
    }
    function addScore(n) {
      const before = state.score;
      state.score += n;
      if (before < 1e4 && state.score >= 1e4) {
        state.lives += 1;
        toast("Spare pair. Extra life.");
        beep(880, 0.12, "square", 0.06);
      }
      if (state.score > high) {
        high = state.score;
        storeSet(HS_KEY, String(high));
      }
      emit();
    }
    function killShip(reason) {
      const ship = state.ship;
      if (!ship || ship.inv > 0) return;
      burst(ship.x, ship.y, COLORS.pink, 18);
      noiseBurst(0.25, 0.1);
      beep(140, 0.35, "sawtooth", 0.05);
      state.lives -= 1;
      state.dyingT = 0.85;
      state.mode = "DYING";
      toast(reason);
      state.ship = null;
      emit();
    }
    function start() {
      ensureAudio();
      state.score = 0;
      state.lives = 10;
      state.wave = 1;
      state.shots = [];
      state.bolts = [];
      state.sparks = [];
      state.tokens = [];
      state.ship = makeShip();
      spawnWave(1);
      state.mode = "PLAYING";
      toast("Hey cuties.", 1.6);
      beep(520, 0.08, "square", 0.05);
      emit();
    }
    function respawn() {
      if (state.lives <= 0) {
        state.mode = "GAMEOVER";
        state.toast = null;
        state.toastT = 0;
        emit();
        return;
      }
      state.ship = makeShip();
      state.mode = "PLAYING";
      emit();
    }
    function beginClear() {
      if (state.mode !== "PLAYING") return;
      state.mode = "WAVECLEAR";
      state.waveClearT = 1.6;
      addScore(100 * state.wave);
      toast("Drawer of space: tidy.", 1.6);
      emit();
    }
    function colorFor(type) {
      return {
        red: COLORS.red,
        lipstick: COLORS.pink,
        heel: COLORS.frost,
        pearl: COLORS.frost,
        phone: COLORS.phone,
        purse: COLORS.gold
      }[type] || COLORS.gum;
    }
    function has(code) {
      return keys.has(code) || extraKeys.includes(code);
    }
    function leftHeld() {
      return has("ArrowLeft") || has("KeyA") || hold.left;
    }
    function rightHeld() {
      return has("ArrowRight") || has("KeyD") || hold.right;
    }
    function thrustHeld() {
      return has("ArrowUp") || has("KeyW") || hold.thrust;
    }
    function fireHeld() {
      return has("Space") || hold.fire;
    }
    function hyperHeld() {
      return has("ShiftLeft") || has("ShiftRight") || hold.hyper;
    }
    function tickFx(dt) {
      for (const p of state.sparks) {
        p.t -= dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
      }
      state.sparks = state.sparks.filter((p) => p.t > 0);
      if (state.sparks.length > 80) state.sparks.splice(0, state.sparks.length - 80);
    }
    function update(dt) {
      if (state.toastT > 0) {
        state.toastT -= dt;
        if (state.toastT <= 0) {
          state.toast = null;
          emit();
        }
      }
      if (state.pinkT > 0) state.pinkT -= dt;
      state.attractT += dt;
      if (state.mode === "PAUSED") return;
      if (state.mode === "ATTRACT" || state.mode === "GAMEOVER") {
        if (!state.rocks.length) spawnWave(1);
        for (const r of state.rocks) {
          r.x = wrap(r.x + r.vx * dt * 0.4, W);
          r.y = wrap(r.y + r.vy * dt * 0.4, H);
          r.rot += r.spin * dt;
        }
        return;
      }
      if (state.mode === "DYING") {
        state.dyingT -= dt;
        tickFx(dt);
        if (state.dyingT <= 0) respawn();
        return;
      }
      if (state.mode === "WAVECLEAR") {
        state.waveClearT -= dt;
        tickFx(dt);
        if (state.waveClearT <= 0) {
          state.wave += 1;
          if (state.ship) {
            state.ship.x = W / 2;
            state.ship.y = H / 2;
            state.ship.vx = 0;
            state.ship.vy = 0;
            state.ship.inv = 2;
          }
          spawnWave(state.wave);
          state.mode = "PLAYING";
          toast("Fresh load.", 1.4);
          emit();
        }
        return;
      }
      const ship = state.ship;
      if (ship) {
        const turn = ship.smear > 0 ? 2.2 : 4;
        if (leftHeld()) ship.a -= turn * dt;
        if (rightHeld()) ship.a += turn * dt;
        if (ship.smear > 0) ship.smear -= dt;
        if (ship.noThrust > 0) ship.noThrust -= dt;
        if (ship.inv > 0) ship.inv -= dt;
        if (ship.hyperCd > 0) ship.hyperCd -= dt;
        if (ship.fireCd > 0) ship.fireCd -= dt;
        if (thrustHeld() && ship.noThrust <= 0) {
          ship.vx += Math.cos(ship.a) * 180 * dt;
          ship.vy += Math.sin(ship.a) * 180 * dt;
          if (Math.random() < 0.4) {
            state.sparks.push({
              x: ship.x - Math.cos(ship.a) * 12,
              y: ship.y - Math.sin(ship.a) * 12,
              vx: -Math.cos(ship.a) * 60 + rand(-20, 20),
              vy: -Math.sin(ship.a) * 60 + rand(-20, 20),
              t: 0.2,
              color: COLORS.gold,
              w: 2
            });
          }
        }
        const spd = Math.hypot(ship.vx, ship.vy);
        if (spd > 260) {
          ship.vx = ship.vx / spd * 260;
          ship.vy = ship.vy / spd * 260;
        }
        const damp = Math.exp(-0.38 * dt);
        ship.vx *= damp;
        ship.vy *= damp;
        ship.x = wrap(ship.x + ship.vx * dt, W);
        ship.y = wrap(ship.y + ship.vy * dt, H);
        if (fireHeld() && ship.fireCd <= 0 && state.shots.length < 4) {
          state.shots.push({
            x: ship.x + Math.cos(ship.a) * 14,
            y: ship.y + Math.sin(ship.a) * 14,
            vx: Math.cos(ship.a) * 380 + ship.vx * 0.3,
            vy: Math.sin(ship.a) * 380 + ship.vy * 0.3,
            t: 0.9
          });
          ship.fireCd = 0.18;
          beep(720, 0.05, "square", 0.04);
        }
        if (hyperHeld() && ship.hyperCd <= 0) {
          ship.hyperCd = 3;
          ship.x = rand(40, W - 40);
          ship.y = rand(40, H - 40);
          ship.vx = 0;
          ship.vy = 0;
          ship.inv = Math.max(ship.inv, 0.6);
          toast("Other dressing room.", 1.2);
          beep(240, 0.08, "triangle", 0.05);
        }
      }
      for (const s of state.shots) {
        s.t -= dt;
        s.x = wrap(s.x + s.vx * dt, W);
        s.y = wrap(s.y + s.vy * dt, H);
      }
      state.shots = state.shots.filter((s) => s.t > 0);
      state.dimShots = state.rocks.some((r) => r.alive && r.type === "phone");
      for (const r of state.rocks) {
        if (!r.alive) continue;
        r.x = wrap(r.x + r.vx * dt, W);
        r.y = wrap(r.y + r.vy * dt, H);
        r.rot += r.spin * dt;
      }
      for (const s of state.shots) {
        for (const r of state.rocks) {
          if (!r.alive || s.t <= 0) continue;
          if (dist2(s, r) < (r.r + 3) * (r.r + 3)) {
            s.t = 0;
            r.alive = false;
            addScore(pointsFor(r.size));
            burst(r.x, r.y, colorFor(r.type), 10);
            noiseBurst(0.12, 0.07);
            state.rocks.push(...splitRock(r));
            if (r.type === "lipstick" && state.ship) {
              state.ship.smear = 3;
              toast("Lipstick on the White Frost. Tragic.");
            }
            if (r.type === "purse") {
              state.tokens.push({ x: r.x, y: r.y, t: 8 });
            }
          }
        }
      }
      if (ship && ship.inv <= 0) {
        for (const r of state.rocks) {
          if (!r.alive) continue;
          if (dist2(ship, r) < (ship.r + r.r * 0.85) * (ship.r + r.r * 0.85)) {
            let reason = "It's fine. We have extras.";
            if (r.type === "red") reason = "There it is. The red one. Everything's pink now.";
            if (r.type === "lipstick") reason = "Lipstick on the White Frost. Tragic.";
            if (r.type === "heel") reason = "Heel's gone. You're hopping, sweetheart.";
            if (r.type === "pearl") reason = "Pearls everywhere. Don't slip.";
            if (r.type === "phone") reason = "Phone's at 1%. The map just died.";
            if (r.type === "purse") reason = "Purse is on the kitchen table.";
            r.alive = false;
            state.rocks.push(...splitRock(r));
            killShip(reason);
            break;
          }
        }
      }
      for (const tok of state.tokens) {
        tok.t -= dt;
        tok.y = wrap(tok.y + 12 * dt, H);
        if (ship && dist2(ship, tok) < 18 * 18) {
          tok.t = 0;
          addScore(50);
          toast("Spare pair.", 1.2);
          beep(660, 0.1, "square", 0.05);
        }
      }
      state.tokens = state.tokens.filter((t) => t.t > 0);
      const bigLeft = state.rocks.filter((r) => r.alive && (r.size === "L" || r.size === "M"));
      state.ufoTimer += dt;
      if (!state.ufo && (bigLeft.length === 0 || state.ufoTimer > 25) && state.mode === "PLAYING") {
        const fromLeft = Math.random() < 0.5;
        state.ufo = {
          x: fromLeft ? -20 : W + 20,
          y: rand(70, H - 70),
          vx: fromLeft ? 70 : -70,
          r: 20,
          fire: 1.2,
          life: 12,
          phase: 0
        };
        toast("Bleach bottle incoming.", 1.4);
      }
      if (state.ufo) {
        const u = state.ufo;
        u.phase += dt;
        u.x += u.vx * dt;
        u.life -= dt;
        u.fire -= dt;
        if (u.fire <= 0 && ship) {
          u.fire = 1.6;
          const a = angTo(u, ship) + rand(-0.15, 0.15);
          state.bolts.push({
            x: u.x,
            y: u.y,
            vx: Math.cos(a) * 220,
            vy: Math.sin(a) * 220,
            t: 2.2
          });
          beep(180, 0.08, "square", 0.04);
        }
        if (u.x < -40 || u.x > W + 40 || u.life <= 0) {
          state.ufo = null;
          if (bigLeft.length === 0) beginClear();
        } else {
          for (const s of state.shots) {
            if (s.t > 0 && dist2(s, u) < (u.r + 3) * (u.r + 3)) {
              s.t = 0;
              burst(u.x, u.y, COLORS.bleach, 16);
              addScore(400);
              state.ufo = null;
              toast("Bleach bottle down.", 1.4);
              noiseBurst(0.2, 0.09);
              if (bigLeft.length === 0) beginClear();
              break;
            }
          }
          if (state.ufo && ship && ship.inv <= 0 && dist2(ship, u) < (ship.r + u.r) * (ship.r + u.r)) {
            killShip("Bleach bottle ruined a pair.");
          }
        }
      }
      for (const b of state.bolts) {
        b.t -= dt;
        b.x = wrap(b.x + b.vx * dt, W);
        b.y = wrap(b.y + b.vy * dt, H);
        if (ship && ship.inv <= 0 && dist2(ship, b) < 14 * 14) {
          b.t = 0;
          if (!ship.white) {
            killShip("Bleach on Hot Pink.");
          }
        }
      }
      state.bolts = state.bolts.filter((b) => b.t > 0);
      if (!state.ufo && bigLeft.length === 0 && !state.rocks.some((r) => r.alive)) {
        beginClear();
      }
      tickFx(dt);
      state.rocks = state.rocks.filter((r) => r.alive);
    }
    function drawBow(cx, cy, s) {
      const k = Math.max(2.4, s * 0.11);
      ctx.beginPath();
      ctx.moveTo(cx - k * 0.2, cy);
      ctx.bezierCurveTo(cx - k * 1.85, cy - k * 1.05, cx - k * 1.9, cy + k * 0.85, cx - k * 0.15, cy + k * 0.2);
      ctx.closePath();
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(cx + k * 0.2, cy);
      ctx.bezierCurveTo(cx + k * 1.85, cy - k * 1.05, cx + k * 1.9, cy + k * 0.85, cx + k * 0.15, cy + k * 0.2);
      ctx.closePath();
      ctx.stroke();
      ctx.beginPath();
      ctx.ellipse(cx, cy + k * 0.02, k * 0.28, k * 0.4, 0, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(cx - k * 0.12, cy + k * 0.28);
      ctx.lineTo(cx - k * 0.75, cy + k * 1.45);
      ctx.lineTo(cx + k * 0.02, cy + k * 0.85);
      ctx.closePath();
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(cx + k * 0.12, cy + k * 0.28);
      ctx.lineTo(cx + k * 0.75, cy + k * 1.45);
      ctx.lineTo(cx - k * 0.02, cy + k * 0.85);
      ctx.closePath();
      ctx.stroke();
    }
    function sampleQuad(ax, ay, cpx, cpy, bx, by, n) {
      const pts = [];
      for (let i = 0; i <= n; i++) {
        const t = i / n;
        const mt = 1 - t;
        pts.push({
          x: mt * mt * ax + 2 * mt * t * cpx + t * t * bx,
          y: mt * mt * ay + 2 * mt * t * cpy + t * t * by
        });
      }
      return pts;
    }
    function scallopPath(pts, amp, side) {
      if (pts.length < 2) return;
      ctx.beginPath();
      ctx.moveTo(pts[0].x, pts[0].y);
      for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i];
        const b = pts[i + 1];
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const len = Math.hypot(dx, dy) || 1;
        ctx.quadraticCurveTo(
          (a.x + b.x) / 2 + -dy / len * side * amp,
          (a.y + b.y) / 2 + dx / len * side * amp,
          b.x,
          b.y
        );
      }
      ctx.stroke();
    }
    function laceBloom(x, y, r) {
      ctx.beginPath();
      for (let i = 0; i < 5; i++) {
        const a = i / 5 * Math.PI * 2;
        ctx.ellipse(x + Math.cos(a) * r * 0.35, y + Math.sin(a) * r * 0.35, r * 0.32, r * 0.18, a, 0, Math.PI * 2);
      }
      ctx.stroke();
    }
    function drawBrief(s, lace) {
      const w = s * 1.05;
      const h = s * 1.05;
      ctx.lineWidth = Math.max(1.1, s * 0.035);
      ctx.beginPath();
      ctx.moveTo(-w * 0.86, -h * 0.48);
      ctx.quadraticCurveTo(0, -h * 0.38, w * 0.86, -h * 0.48);
      ctx.lineTo(w * 0.96, -h * 0.2);
      ctx.quadraticCurveTo(w * 0.55, h * 0.18, w * 0.16, h * 0.86);
      ctx.lineTo(-w * 0.16, h * 0.86);
      ctx.quadraticCurveTo(-w * 0.55, h * 0.18, -w * 0.96, -h * 0.2);
      ctx.closePath();
      ctx.stroke();
      ctx.lineWidth = Math.max(0.75, s * 0.022);
      if (lace) {
        scallopPath(sampleQuad(-w * 0.86, -h * 0.48, 0, -h * 0.38, w * 0.86, -h * 0.48, 12), s * 0.055, -1);
        scallopPath(sampleQuad(w * 0.96, -h * 0.2, w * 0.55, h * 0.18, w * 0.16, h * 0.86, 10), s * 0.05, 1);
        scallopPath(sampleQuad(-w * 0.16, h * 0.86, -w * 0.55, h * 0.18, -w * 0.96, -h * 0.2, 10), s * 0.05, 1);
      } else {
        scallopPath(sampleQuad(-w * 0.86, -h * 0.48, 0, -h * 0.38, w * 0.86, -h * 0.48, 10), s * 0.045, -1);
      }
      ctx.lineWidth = Math.max(0.9, s * 0.028);
      ctx.beginPath();
      ctx.moveTo(-w * 0.82, -h * 0.36);
      ctx.quadraticCurveTo(0, -h * 0.26, w * 0.82, -h * 0.36);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-w * 0.32, -h * 0.34);
      ctx.quadraticCurveTo(-w * 0.22, h * 0.12, -w * 0.14, h * 0.72);
      ctx.moveTo(w * 0.32, -h * 0.34);
      ctx.quadraticCurveTo(w * 0.22, h * 0.12, w * 0.14, h * 0.72);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-w * 0.9, -h * 0.16);
      ctx.quadraticCurveTo(-w * 0.48, h * 0.16, -w * 0.2, h * 0.78);
      ctx.moveTo(w * 0.9, -h * 0.16);
      ctx.quadraticCurveTo(w * 0.48, h * 0.16, w * 0.2, h * 0.78);
      ctx.stroke();
      drawBow(0, -h * 0.42, s);
    }
    function drawThong(s) {
      const w = s * 1.05;
      const h = s * 1.05;
      ctx.lineWidth = Math.max(1.1, s * 0.035);
      ctx.beginPath();
      ctx.moveTo(-w * 0.92, -h * 0.58);
      ctx.lineTo(-w * 0.5, -h * 0.22);
      ctx.quadraticCurveTo(0, -h * 0.12, w * 0.5, -h * 0.22);
      ctx.lineTo(w * 0.92, -h * 0.58);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-w * 0.5, -h * 0.22);
      ctx.quadraticCurveTo(-w * 0.28, h * 0.28, -w * 0.14, h * 0.86);
      ctx.lineTo(w * 0.14, h * 0.86);
      ctx.quadraticCurveTo(w * 0.28, h * 0.28, w * 0.5, -h * 0.22);
      ctx.closePath();
      ctx.stroke();
      ctx.lineWidth = Math.max(0.75, s * 0.022);
      ctx.beginPath();
      ctx.moveTo(-w * 0.46, -h * 0.14);
      ctx.quadraticCurveTo(0, -h * 0.04, w * 0.46, -h * 0.14);
      ctx.stroke();
      scallopPath(sampleQuad(-w * 0.5, -h * 0.22, -w * 0.28, h * 0.28, -w * 0.14, h * 0.86, 8), s * 0.048, -1);
      scallopPath(sampleQuad(w * 0.14, h * 0.86, w * 0.28, h * 0.28, w * 0.5, -h * 0.22, 8), s * 0.048, -1);
      ctx.lineWidth = Math.max(0.9, s * 0.028);
      drawBow(0, -h * 0.18, s);
    }
    function drawRuffle(s) {
      const w = s * 1.08;
      const h = s * 1.02;
      ctx.lineWidth = Math.max(1.15, s * 0.036);
      ctx.beginPath();
      ctx.moveTo(-w * 0.98, -h * 0.54);
      ctx.lineTo(w * 0.98, -h * 0.54);
      ctx.lineTo(w * 0.95, -h * 0.38);
      ctx.lineTo(-w * 0.95, -h * 0.38);
      ctx.closePath();
      ctx.stroke();
      ctx.lineWidth = Math.max(0.55, s * 0.016);
      for (let i = 1; i < 16; i++) {
        const x = -w * 0.9 + w * 1.8 * (i / 16);
        ctx.beginPath();
        ctx.moveTo(x, -h * 0.53);
        ctx.lineTo(x, -h * 0.39);
        ctx.stroke();
      }
      ctx.lineWidth = Math.max(1.05, s * 0.03);
      ctx.beginPath();
      ctx.moveTo(-w * 1.04, -h * 0.38);
      const waves = 8;
      for (let i = 0; i < waves; i++) {
        const x0 = -w * 1.04 + w * 2.08 * (i / waves);
        const x1 = -w * 1.04 + w * 2.08 * ((i + 1) / waves);
        const amp = h * (i % 2 === 0 ? 0.24 : 0.15);
        ctx.quadraticCurveTo((x0 + x1) / 2, -h * 0.38 + amp, x1, -h * 0.36);
      }
      ctx.stroke();
      ctx.lineWidth = Math.max(0.6, s * 0.018);
      for (let i = 1; i < waves; i++) {
        const x = -w * 1.04 + w * 2.08 * (i / waves);
        ctx.beginPath();
        ctx.moveTo(x, -h * 0.38);
        ctx.lineTo(x + (i % 2 === 0 ? -w * 0.02 : w * 0.02), -h * 0.2);
        ctx.stroke();
      }
      ctx.lineWidth = Math.max(1.15, s * 0.035);
      ctx.beginPath();
      ctx.moveTo(-w * 0.78, -h * 0.12);
      ctx.quadraticCurveTo(-w * 0.42, h * 0.22, -w * 0.16, h * 0.88);
      ctx.lineTo(w * 0.16, h * 0.88);
      ctx.quadraticCurveTo(w * 0.42, h * 0.22, w * 0.78, -h * 0.12);
      ctx.stroke();
      ctx.lineWidth = Math.max(0.8, s * 0.022);
      scallopPath(sampleQuad(-w * 0.78, -h * 0.12, -w * 0.42, h * 0.22, -w * 0.16, h * 0.88, 10), s * 0.07, -1);
      scallopPath(sampleQuad(w * 0.16, h * 0.88, w * 0.42, h * 0.22, w * 0.78, -h * 0.12, 10), s * 0.07, -1);
      ctx.lineWidth = Math.max(0.6, s * 0.016);
      const left = sampleQuad(-w * 0.78, -h * 0.12, -w * 0.42, h * 0.22, -w * 0.16, h * 0.88, 8);
      const right = sampleQuad(w * 0.16, h * 0.88, w * 0.42, h * 0.22, w * 0.78, -h * 0.12, 8);
      for (const p of [...left, ...right]) {
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        ctx.lineTo(p.x * 0.92, p.y * 0.92);
        ctx.stroke();
      }
      drawBow(0, -h * 0.46, s * 1.25);
    }
    function drawPanty(s, cut) {
      if (s < 8) {
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(-s * 0.85, -s * 0.25);
        ctx.lineTo(s * 0.85, -s * 0.25);
        ctx.lineTo(0, s * 0.9);
        ctx.closePath();
        ctx.stroke();
        return;
      }
      if (cut === "thong") drawThong(s);
      else if (cut === "ruffle") drawRuffle(s);
      else drawBrief(s, cut === "lace");
    }
    function drawBra(s) {
      const w = s * 1.08;
      ctx.lineWidth = Math.max(1.15, s * 0.036);
      ctx.beginPath();
      ctx.moveTo(-w * 1.02, s * 0.06);
      ctx.lineTo(-w * 1.02, s * 0.42);
      ctx.lineTo(-w * 0.62, s * 0.4);
      ctx.quadraticCurveTo(0, s * 0.26, w * 0.62, s * 0.4);
      ctx.lineTo(w * 1.02, s * 0.42);
      ctx.lineTo(w * 1.02, s * 0.06);
      ctx.lineTo(w * 0.7, s * 0.02);
      ctx.quadraticCurveTo(0, s * 0.16, -w * 0.7, s * 0.02);
      ctx.closePath();
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-w * 1.02, s * 0.4);
      ctx.lineTo(-w * 0.62, s * 0.38);
      ctx.quadraticCurveTo(0, s * 0.24, w * 0.62, s * 0.38);
      ctx.lineTo(w * 1.02, s * 0.4);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-w * 0.78, s * 0.06);
      ctx.lineTo(-w * 0.78, s * 0.4);
      ctx.moveTo(w * 0.78, s * 0.06);
      ctx.lineTo(w * 0.78, s * 0.4);
      ctx.stroke();
      ctx.lineWidth = Math.max(0.55, s * 0.016);
      ctx.setLineDash([s * 0.05, s * 0.04]);
      ctx.beginPath();
      ctx.moveTo(-w * 0.98, s * 0.12);
      ctx.lineTo(-w * 0.8, s * 0.1);
      ctx.moveTo(w * 0.8, s * 0.1);
      ctx.lineTo(w * 0.98, s * 0.12);
      ctx.moveTo(-w * 0.62, s * 0.36);
      ctx.quadraticCurveTo(0, s * 0.22, w * 0.62, s * 0.36);
      ctx.stroke();
      ctx.setLineDash([]);
      const cup = (side) => {
        const k = side;
        ctx.lineWidth = Math.max(1.2, s * 0.038);
        ctx.beginPath();
        ctx.moveTo(k * w * 0.06, s * 0.14);
        ctx.bezierCurveTo(k * w * 0.08, -s * 0.08, k * w * 0.22, -s * 0.32, k * w * 0.48, -s * 0.16);
        ctx.quadraticCurveTo(k * w * 0.66, -s * 0.02, k * w * 0.62, s * 0.16);
        ctx.quadraticCurveTo(k * w * 0.52, s * 0.42, k * w * 0.22, s * 0.4);
        ctx.quadraticCurveTo(k * w * 0.06, s * 0.32, k * w * 0.06, s * 0.14);
        ctx.closePath();
        ctx.stroke();
        ctx.lineWidth = Math.max(0.75, s * 0.02);
        scallopPath(
          sampleQuad(k * w * 0.1, s * 0.02, k * w * 0.28, -s * 0.3, k * w * 0.52, -s * 0.14, 8),
          s * 0.055,
          -1
        );
        if (s > 18) {
          laceBloom(k * w * 0.28, -s * 0.16, s * 0.07);
          laceBloom(k * w * 0.4, -s * 0.08, s * 0.055);
        }
      };
      cup(-1);
      cup(1);
      const strap = (side) => {
        const k = side;
        const x0 = k * w * 0.5;
        const y0 = -s * 0.16;
        const x1 = k * w * 0.58;
        const y1 = -s * 0.92;
        const tw = s * 0.065;
        ctx.lineWidth = Math.max(1.05, s * 0.03);
        ctx.beginPath();
        ctx.moveTo(x0 - tw, y0);
        ctx.lineTo(x1 - tw * 0.7, y1);
        ctx.lineTo(x1 + tw * 0.7, y1);
        ctx.lineTo(x0 + tw, y0);
        ctx.closePath();
        ctx.stroke();
        const bx = x0 + (x1 - x0) * 0.42;
        const by = y0 + (y1 - y0) * 0.42;
        ctx.strokeRect(bx - s * 0.07, by - s * 0.035, s * 0.14, s * 0.07);
      };
      strap(-1);
      strap(1);
      ctx.lineWidth = Math.max(0.95, s * 0.028);
      drawBow(0, s * 0.1, s * 0.95);
    }
    // Bleach bottle villain (handle + neck + body + cap). Bolts ruin Hot Pink panties.
    function drawBleachBottle(x, y, phase) {
      ctx.save();
      ctx.translate(x, y);
      // Gentle bob so the bottle feels alive while it strafes
      ctx.translate(0, Math.sin((phase || 0) * 4) * 1.5);
      ctx.strokeStyle = COLORS.bleach;
      ctx.lineWidth = 1.6;
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      // Body — classic jug silhouette (wider base, tapered shoulders)
      ctx.beginPath();
      ctx.moveTo(-11, 14);
      ctx.lineTo(11, 14);
      ctx.lineTo(9, 2);
      ctx.lineTo(5, -6);
      ctx.lineTo(-5, -6);
      ctx.lineTo(-9, 2);
      ctx.closePath();
      ctx.stroke();
      // Neck
      ctx.beginPath();
      ctx.moveTo(-3.5, -6);
      ctx.lineTo(-3.5, -10);
      ctx.lineTo(3.5, -10);
      ctx.lineTo(3.5, -6);
      ctx.stroke();
      // Cap / spout
      ctx.strokeRect(-4, -14, 8, 4);
      // Side handle (left)
      ctx.beginPath();
      ctx.moveTo(-9, 0);
      ctx.quadraticCurveTo(-16, 2, -16, 8);
      ctx.quadraticCurveTo(-16, 12, -9, 11);
      ctx.stroke();
      // Label band + tiny skull-ish mark (bleach danger wink)
      ctx.beginPath();
      ctx.moveTo(-7, 5);
      ctx.lineTo(7, 5);
      ctx.moveTo(-7, 8);
      ctx.lineTo(7, 8);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(0, 6.5, 2.2, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    }
    // Hair bow silhouette (Manager sample D): loops + center knot + tails.
    // Right loop tip = heading (+X local), same rotate(a) as the old iron.
    function drawHairBowShip(x, y, a, strokeCol, thrusting) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(a);
      ctx.strokeStyle = strokeCol;
      ctx.lineWidth = 1.6;
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      // Right loop — angular pentagon, outer tip on +X midline (heading)
      ctx.beginPath();
      ctx.moveTo(2.2, -2.4);
      ctx.lineTo(6.5, -7.5);
      ctx.lineTo(14, 0);
      ctx.lineTo(6.5, 7.5);
      ctx.lineTo(2.2, 2.4);
      ctx.closePath();
      ctx.stroke();
      // Left loop — mirror (aft)
      ctx.beginPath();
      ctx.moveTo(-2.2, -2.4);
      ctx.lineTo(-6.5, -7.5);
      ctx.lineTo(-14, 0);
      ctx.lineTo(-6.5, 7.5);
      ctx.lineTo(-2.2, 2.4);
      ctx.closePath();
      ctx.stroke();
      // Center knot — outer + inner circle (gameplay sample)
      ctx.beginPath();
      ctx.arc(0, 0, 3.1, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(0, 0, 1.45, 0, Math.PI * 2);
      ctx.stroke();
      // Tails — two strokes down/out from knot
      ctx.beginPath();
      ctx.moveTo(-1.2, 3.1);
      ctx.lineTo(-5.5, 12.5);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(1.2, 3.1);
      ctx.lineTo(5.5, 12.5);
      ctx.stroke();
      // Thrust sparkle from aft (left loop tip)
      if (thrusting) {
        ctx.beginPath();
        ctx.moveTo(-14, 0);
        ctx.lineTo(-23, 0);
        ctx.strokeStyle = COLORS.gold;
        ctx.stroke();
      }
      ctx.restore();
    }
    function drawWrapped(obj, fn) {
      for (const ox of [-W, 0, W]) {
        for (const oy of [-H, 0, H]) {
          if (ox === 0 && oy === 0) fn(obj.x, obj.y);
          else if (obj.x + ox > -50 && obj.x + ox < W + 50 && obj.y + oy > -50 && obj.y + oy < H + 50) {
            fn(obj.x + ox, obj.y + oy);
          }
        }
      }
    }
    function draw() {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (canvas.width !== Math.floor(W * dpr) || canvas.height !== Math.floor(H * dpr)) {
        canvas.width = Math.floor(W * dpr);
        canvas.height = Math.floor(H * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.imageSmoothingEnabled = false;
      ctx.fillStyle = "#050308";
      ctx.fillRect(0, 0, W, H);
      for (const st of stars) {
        ctx.fillStyle = `rgba(244,240,234,${state.pinkT > 0 ? st.a * 0.35 : st.a})`;
        ctx.fillRect(st.x, st.y, st.s, st.s);
      }
      ctx.lineWidth = 1.6;
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      for (const r of state.rocks) {
        if (!r.alive) continue;
        ctx.strokeStyle = colorFor(r.type);
        drawWrapped(r, (x, y) => {
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(r.rot);
          if (r.garment === "bra") drawBra(r.r);
          else drawPanty(r.r, r.cut);
          ctx.restore();
        });
      }
      ctx.fillStyle = state.dimShots ? "rgba(244,240,234,0.28)" : COLORS.frost;
      for (const s2 of state.shots) ctx.fillRect(s2.x - 1, s2.y - 1, 3, 3);
      ctx.fillStyle = COLORS.bleach;
      for (const b of state.bolts) ctx.fillRect(b.x - 3, b.y - 3, 7, 7);
      for (const p of state.sparks) {
        ctx.globalAlpha = Math.max(0, p.t * 2);
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x, p.y, p.w, p.w);
      }
      ctx.globalAlpha = 1;
      if (state.ufo) {
        const u = state.ufo;
        drawBleachBottle(u.x, u.y, u.phase);
      }
      const s = state.ship;
      if (s && !(s.inv > 0 && Math.floor(s.inv * 10) % 2 === 0)) {
        const col = s.white ? COLORS.frost : COLORS.pink;
        const strokeCol = s.smear > 0 ? COLORS.red : col;
        const thrusting = thrustHeld() && s.noThrust <= 0 && state.mode === "PLAYING";
        drawWrapped(s, (x, y) => {
          drawHairBowShip(x, y, s.a, strokeCol, thrusting);
        });
      }
      for (const tok of state.tokens) {
        ctx.strokeStyle = COLORS.pink;
        ctx.strokeRect(tok.x - 5, tok.y - 4, 10, 8);
      }
      if (state.pinkT > 0) {
        ctx.fillStyle = `rgba(255,143,191,${0.22 + state.pinkT})`;
        ctx.fillRect(0, 0, W, H);
      }
      // DOM overlay owns ATTRACT / GAMEOVER copy — skip canvas HUD/toast pileup.
      if (state.mode !== "ATTRACT" && state.mode !== "GAMEOVER") {
        ctx.font = "14px 'IBM Plex Mono', ui-monospace, monospace";
        ctx.fillStyle = COLORS.pink;
        ctx.textAlign = "left";
        ctx.fillText(`SCORE ${state.score}`, 12, 22);
        ctx.fillStyle = COLORS.gum;
        ctx.textAlign = "center";
        ctx.fillText(`WAVE ${state.wave}`, W / 2, 22);
        ctx.fillStyle = COLORS.gold;
        ctx.textAlign = "right";
        ctx.fillText(`HI ${high}`, W - 12, 22);
        if (muted) {
          ctx.fillStyle = COLORS.mid;
          ctx.fillText("MUTE", W - 12, 40);
        }
        ctx.strokeStyle = COLORS.pink;
        for (let i = 0; i < state.lives; i++) {
          const col = i % 10;
          const row = Math.floor(i / 10);
          ctx.strokeRect(12 + col * 14, 32 + row * 12, 10, 8);
        }
        if (state.toast) {
          ctx.fillStyle = COLORS.gum;
          ctx.textAlign = "center";
          ctx.font = "13px 'IBM Plex Mono', ui-monospace, monospace";
          ctx.fillText(state.toast, W / 2, H - 28);
        }
      }
      if (state.mode === "PAUSED") {
        ctx.fillStyle = "rgba(5,3,8,0.45)";
        ctx.fillRect(0, 0, W, H);
        ctx.fillStyle = COLORS.gold;
        ctx.textAlign = "center";
        ctx.font = "24px 'IBM Plex Mono', ui-monospace, monospace";
        ctx.fillText("PAUSED", W / 2, H / 2);
      }
      if (state.mode === "WAVECLEAR") {
        ctx.fillStyle = COLORS.gold;
        ctx.textAlign = "center";
        ctx.font = "22px 'IBM Plex Mono', ui-monospace, monospace";
        ctx.fillText("LOAD CLEAN", W / 2, H / 2);
      }
    }
    function frame(now) {
      if (destroyed) return;
      let dt = (now - last) / 1e3;
      last = now;
      if (dt > 0.05) dt = 0.05;
      update(dt);
      draw();
      raf = requestAnimationFrame(frame);
    }
    function isGameKey(code) {
      return [
        "Space", "Enter", "Escape",
        "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight",
        "KeyW", "KeyA", "KeyS", "KeyD",
        "KeyM", "KeyP",
        "ShiftLeft", "ShiftRight"
      ].includes(code);
    }
    function onKeyDown(e) {
      if (e.repeat && (e.code === "Space" || e.code === "Enter")) return;
      keys.add(e.code);
      if (isGameKey(e.code)) {
        // Keep browser/theme from scrolling or activating focused pad/start buttons.
        e.preventDefault();
      }
      if (e.code === "KeyM") {
        muted = !muted;
        storeSet(MUTE_KEY, muted ? "1" : "0");
        emit();
      }
      if (e.code === "KeyP" || e.code === "Escape") {
        if (state.mode === "PLAYING") {
          state.mode = "PAUSED";
          emit();
        } else if (state.mode === "PAUSED") {
          state.mode = "PLAYING";
          emit();
        }
      }
      if (e.code === "Enter" || e.code === "Space") {
        if (state.mode === "ATTRACT" || state.mode === "GAMEOVER") {
          start();
        }
      }
      ensureAudio();
    }
    function onKeyUp(e) {
      keys.delete(e.code);
    }
    function onBlur() {
      keys.clear();
    }
    // Capture on window so parlor focus / pad buttons cannot swallow WASD/arrows/space.
    window.addEventListener("keydown", onKeyDown, true);
    window.addEventListener("keyup", onKeyUp, true);
    window.addEventListener("blur", onBlur);
    spawnWave(1);
    emit();
    raf = requestAnimationFrame(frame);
    const probe = {
      getYaw: () => state.ship ? -state.ship.a : 0,
      getSpeed: () => state.ship ? Math.hypot(state.ship.vx, state.ship.vy) : 0,
      getMode: () => state.mode,
      start,
      setKeys: (codes) => {
        for (const c of extraKeys) keys.delete(c);
        extraKeys = codes.slice();
        for (const c of extraKeys) keys.add(c);
      },
      setSteer: (v) => {
        hold.left = v > 0.2;
        hold.right = v < -0.2;
      }
    };
    window.__controlsTest = probe;
    return {
      destroy() {
        destroyed = true;
        cancelAnimationFrame(raf);
        window.removeEventListener("keydown", onKeyDown, true);
        window.removeEventListener("keyup", onKeyUp, true);
        window.removeEventListener("blur", onBlur);
      },
      start,
      pause() {
        if (state.mode === "PLAYING") {
          state.mode = "PAUSED";
          emit();
        } else if (state.mode === "PAUSED") {
          state.mode = "PLAYING";
          emit();
        }
      },
      setHold(act, down) {
        hold[act] = down;
        if (act === "start" && down && (state.mode === "ATTRACT" || state.mode === "GAMEOVER")) {
          start();
        }
      },
      toggleMute() {
        muted = !muted;
        storeSet(MUTE_KEY, muted ? "1" : "0");
        emit();
      }
    };
  }
  return __toCommonJS(laundry_orbit_exports);
})();
if (typeof window !== 'undefined') window.LaundryOrbitEngine = LaundryOrbitEngine;

/* Parlor embed boot — Katie & Laura Laundry Orbit station */
(function () {
  "use strict";

  var eng =
    (typeof LaundryOrbitEngine !== "undefined" && LaundryOrbitEngine) ||
    (typeof window !== "undefined" && window.LaundryOrbitEngine) ||
    null;
  var create = eng && eng.createLaundryOrbit;
  if (!create) {
    console.error("[laundry-orbit] createLaundryOrbit missing");
    return;
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function setPlaying(root, page, on) {
    if (root) root.classList.toggle("is-playing", !!on);
    if (page) page.classList.toggle("is-playing", !!on);
    document.documentElement.classList.toggle("kl-lo-playing", !!on);
    document.body.classList.toggle("kl-lo-playing", !!on);
  }

  /* Vanilla port of virtual-joystick.tsx — analog stick, x/y in [-1,1]. */
  function mountVirtualJoystick(root, onChange, opts) {
    opts = opts || {};
    var size = opts.size || 124;
    var well = root.querySelector(".kl-vj__well") || root;
    var knob = root.querySelector("[data-kl-vj-knob]");
    var pid = null;
    var r = size * 0.32;
    well.style.width = size + "px";
    well.style.height = size + "px";
    if (knob) {
      knob.style.width = size * 0.36 + "px";
      knob.style.height = size * 0.36 + "px";
    }
    function send(x, y) {
      if (knob) {
        knob.style.transform =
          "translate(calc(-50% + " + x * r + "px), calc(-50% + " + y * r + "px))";
      }
      onChange(x, y);
    }
    function fromEvent(e) {
      var b = well.getBoundingClientRect();
      var cx = b.left + b.width / 2;
      var cy = b.top + b.height / 2;
      var dx = e.clientX - cx;
      var dy = e.clientY - cy;
      var max = b.width * 0.32;
      var mag = Math.hypot(dx, dy);
      if (mag > max && mag > 0) {
        dx = (dx / mag) * max;
        dy = (dy / mag) * max;
      }
      send(dx / max, dy / max);
    }
    function down(e) {
      e.preventDefault();
      pid = e.pointerId;
      try {
        well.setPointerCapture(e.pointerId);
      } catch (err) {}
      fromEvent(e);
    }
    function move(e) {
      if (pid !== e.pointerId) return;
      fromEvent(e);
    }
    function up(e) {
      if (pid !== null && e.pointerId !== undefined && pid !== e.pointerId) return;
      pid = null;
      send(0, 0);
    }
    well.addEventListener("pointerdown", down);
    well.addEventListener("pointermove", move);
    well.addEventListener("pointerup", up);
    well.addEventListener("pointercancel", up);
    well.addEventListener("lostpointercapture", up);
  }

  /* iOS Safari: block Copy / Find Selection / Translate long-press callout on pad/canvas.
     touchPrevent: canvas/pad containers may cancel touchstart; pad buttons stay cancel-free
     so iOS still dispatches their pointer/click activation. */
  function suppressIosCallout(el, touchPrevent) {
    if (!el || el.__klNoCallout) return;
    el.__klNoCallout = true;
    var stop = function (ev) {
      ev.preventDefault();
    };
    el.addEventListener("contextmenu", stop, false);
    el.addEventListener("selectstart", stop, false);
    if (touchPrevent) {
      el.addEventListener(
        "touchstart",
        function (ev) {
          if (ev.cancelable) ev.preventDefault();
        },
        { passive: false }
      );
    }
  }

  function bindHold(el, onDown, onUp) {
    if (!el) return;
    var down = function (ev) {
      ev.preventDefault();
      try {
        el.setPointerCapture(ev.pointerId);
      } catch (e) {}
      onDown(ev);
    };
    var up = function () {
      onUp();
    };
    el.addEventListener("pointerdown", down);
    el.addEventListener("pointerup", up);
    el.addEventListener("pointercancel", up);
    el.addEventListener("lostpointercapture", up);
  }

  /* KL HARD LOCK 2026-09-17 Katie: remove Shopify draft/preview bar (late JS inject) */
  function nukeShopifyPreviewBar() {
    var sels = [
      "#preview-bar-iframe",
      "iframe#preview-bar-iframe",
      'iframe[src*="preview_bar"]',
      'iframe[src*="preview-bar"]',
      ".shopify-preview-bar",
      "#shopify-preview-bar",
      ".preview-bar",
      "#PreviewBarCSS",
      "[data-preview-bar]"
    ];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) {
        el.remove();
      });
    });
    try {
      document.documentElement.style.marginBottom = "0";
      document.body.style.marginBottom = "0";
      document.body.style.paddingBottom = "0";
    } catch (e) {}
  }
  nukeShopifyPreviewBar();
  if (window.MutationObserver) {
    var __klPreviewBarMo = new MutationObserver(function () {
      nukeShopifyPreviewBar();
    });
    __klPreviewBarMo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }


  ready(function () {
    var root = document.querySelector("[data-kl-laundry-orbit]");
    if (!root) return;
    var canvas =
      root.querySelector("canvas") || document.getElementById("kl-lo-canvas");
    if (!canvas) return;
    var page =
      root.closest(".kl-laundry-orbit-page") ||
      document.querySelector(".kl-laundry-orbit-page");
    var overlay = root.querySelector("[data-kl-lo-overlay]");
    var startBtn =
      document.getElementById("start-game") ||
      root.querySelector("[data-kl-lo-start]");
    var muteBtn = root.querySelector("[data-kl-lo-mute]");
    var toastEl = root.querySelector("[data-kl-lo-toast]");

    // Stronger anti-callout (Katie iPhone: callout over SHOOT / Dressing rm / SHOOT)
    suppressIosCallout(root, false);
    var stage = root.querySelector(".kl-lo__stage");
    var pad = root.querySelector("[data-kl-lo-pad]") || root.querySelector(".kl-lo__pad");
    suppressIosCallout(stage, false);
    suppressIosCallout(canvas, true);
    suppressIosCallout(pad, true);
    // Keep pad buttons touchstart-cancel-free so iOS dispatches pointer/click activation;
    // bindHold prevents the active pointer event itself and releases on capture loss.
    root.querySelectorAll(".kl-lo__btn, [data-act]").forEach(function (btn) {
      suppressIosCallout(btn, false);
    });
    suppressIosCallout(startBtn, false);
    suppressIosCallout(muteBtn, false);

    var fireHolds = 0;
    var lastMode = "ATTRACT";
    var game = null;

    function syncChrome(snap) {
      var mode = snap && snap.mode;
      if (mode) lastMode = mode;
      var playing =
        mode === "PLAYING" ||
        mode === "PAUSED" ||
        mode === "DYING" ||
        mode === "WAVECLEAR";
      setPlaying(root, page, playing);
      if (overlay) {
        var show = mode === "ATTRACT" || mode === "GAMEOVER";
        var go = mode === "GAMEOVER";
        overlay.hidden = !show;
        overlay.setAttribute("aria-hidden", show ? "false" : "true");
        var kicker = overlay.querySelector("[data-kl-lo-overlay-kicker]");
        var title = overlay.querySelector("[data-kl-lo-overlay-title]");
        var sub = overlay.querySelector("[data-kl-lo-overlay-sub]");
        // ATTRACT: title "Clear the load" + Start only — no kicker/eyebrow, no instruction sub.
        // GAMEOVER: single title + Play again — never reintroduce HEY CUTIES on attract.
        if (kicker) {
          kicker.hidden = true;
          kicker.textContent = "";
        }
        if (title) {
          title.textContent = go
            ? "It's fine. We have extras."
            : "Clear the load";
        }
        if (sub) {
          sub.hidden = true;
          sub.textContent = "";
        }
        if (startBtn) {
          startBtn.textContent = go ? "Play again" : "Start";
        }
      }
      if (muteBtn) {
        muteBtn.setAttribute(
          "aria-pressed",
          snap && snap.muted ? "true" : "false"
        );
        muteBtn.textContent = snap && snap.muted ? "Unmute" : "Mute";
      }
      if (toastEl) toastEl.textContent = (snap && snap.toast) || "";
    }

    game = create(canvas, syncChrome);
    window.KLLaundryOrbit = game;

    /* Quit → /pages/arcade-games (Katie 2026-09-17) */
    (function ensureQuit() {
      if (root.querySelector("[data-kl-quit]")) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "kl-lo__quit";
      btn.setAttribute("data-kl-quit", "");
      btn.setAttribute("aria-label", "Quit to Arcade");
      btn.textContent = "Quit";
      btn.addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        try {
          var g = game || window.KLLaundryOrbit;
          if (g && typeof g.destroy === "function") g.destroy();
        } catch (e) {}
        location.href = "/pages/arcade-games";
      });
      
    root.appendChild(btn);
      if (typeof suppressIosCallout === "function") suppressIosCallout(btn, false);
    })();


    function focusPlayfield() {
      if (!canvas) return;
      if (!canvas.hasAttribute("tabindex")) canvas.setAttribute("tabindex", "0");
      try {
        canvas.focus({ preventScroll: true });
      } catch (e) {
        try {
          canvas.focus();
        } catch (e2) {}
      }
    }

    function begin() {
      if (!game) return;
      game.start();
      if (overlay) {
        overlay.hidden = true;
        overlay.setAttribute("aria-hidden", "true");
      }
      setPlaying(root, page, true);
      // Blur Start/pad so Space cannot re-click a button; canvas takes focus for keys.
      if (document.activeElement && document.activeElement.blur) {
        try {
          document.activeElement.blur();
        } catch (e) {}
      }
      focusPlayfield();
    }

    if (startBtn) {
      startBtn.addEventListener("click", function (ev) {
        ev.preventDefault();
        begin();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener("click", function (ev) {
        ev.preventDefault();
        if (game && game.toggleMute) game.toggleMute();
      });
    }

    function hold(act, down) {
      if (!game) return;
      if (act === "start" && down) {
        begin();
        return;
      }
      game.setHold(act, down);
    }

    function fire(down) {
      if (down) fireHolds += 1;
      else fireHolds = Math.max(0, fireHolds - 1);
      hold("fire", fireHolds > 0);
    }

    root.querySelectorAll("[data-act]").forEach(function (btn) {
      var act = btn.getAttribute("data-act");
      if (!act || act === "fire") return;
      bindHold(
        btn,
        function () {
          btn.classList.add("is-down");
          hold(act, true);
        },
        function () {
          btn.classList.remove("is-down");
          hold(act, false);
        }
      );
    });

    root.querySelectorAll('[data-act="fire"]').forEach(function (btn) {
      bindHold(
        btn,
        function () {
          btn.classList.add("is-down");
          fire(true);
        },
        function () {
          btn.classList.remove("is-down");
          fire(false);
        }
      );
    });

    /* Virtual stick: X → rotate, Y-up → thrust (React laundry-orbit.tsx thresholds). */
    var vjEl = root.querySelector("[data-kl-vj]");
    if (vjEl) {
      suppressIosCallout(vjEl.querySelector(".kl-vj__well") || vjEl, true);
      mountVirtualJoystick(vjEl, function (x, y) {
        hold("left", x < -0.28);
        hold("right", x > 0.28);
        hold("thrust", y < -0.28);
      }, { size: 124 });
    }

    bindHold(
      canvas,
      function () {
        if (lastMode === "ATTRACT" || lastMode === "GAMEOVER") {
          begin();
          return;
        }
        if (
          lastMode === "PLAYING" ||
          lastMode === "WAVECLEAR" ||
          lastMode === "DYING"
        ) {
          fire(true);
        }
      },
      function () {
        fire(false);
      }
    );

    // Parlor hold bridge — maps keys to setHold so pad-focus cannot starve input.
    // Engine window-capture listeners own start / pause / mute / keys Set (no double-start).
    var keyHold = {
      ArrowLeft: "left",
      KeyA: "left",
      ArrowRight: "right",
      KeyD: "right",
      ArrowUp: "thrust",
      KeyW: "thrust",
      Space: "fire",
      ShiftLeft: "hyper",
      ShiftRight: "hyper"
    };
    function onParlorKeyDown(ev) {
      var act = keyHold[ev.code];
      if (!act) return;
      // During attract/gameover Space is start (engine); do not also hold-fire.
      if (act === "fire" && (lastMode === "ATTRACT" || lastMode === "GAMEOVER")) return;
      ev.preventDefault();
      if (act === "fire") fire(true);
      else hold(act, true);
    }
    function onParlorKeyUp(ev) {
      var act = keyHold[ev.code];
      if (!act) return;
      if (act === "fire") fire(false);
      else hold(act, false);
    }
    window.addEventListener("keydown", onParlorKeyDown, true);
    window.addEventListener("keyup", onParlorKeyUp, true);

    if (canvas && !canvas.hasAttribute("tabindex")) {
      canvas.setAttribute("tabindex", "0");
    }

    syncChrome({ mode: "ATTRACT", muted: false, toast: null });
  });
})();
